<template>
    <section class="py-12 bg-white md-max:pt-6">
        <div class="px-4 mx-auto sm:px-6 lg:px-16">
            <div class="grid gap-12 items-start lg:grid-cols-12">

                <!-- Left Column: Content -->
                <div class="lg:col-span-8">
                    <!-- Header Text -->
                    <div class="mb-8">
                        <div class="text-lg font-bold md:tet-xl font-ww-medium" v-html="headerTitle">
                        </div>
                        <p class="text-lg md:text-xl font-ww-regular" v-html="headerDescription">
                        </p>
                    </div>


                </div>



            </div>


            <!-- Red Dashed Box -->
            <div class="relative p-4 mb-8 rounded-sm border-[6px] border-[#D20000] border-dashed !pt-8">
                <!-- Box Heading -->
                <div class="flex flex-col justify-start items-center lg:flex lg:flex-row">
                    <div
                        class="mb-6 text-xl font-extrabold text-center font-ww-bold text-gray-900 xl:text-4xl md:text-3xl xl:w-[637px] md:w-[530px] xl:!leading-[42px]" v-html="boxTitle">
                    </div>

                    <div>
                        <nuxt-img :src="boxImageSrc" :alt="boxImageAlt"
                            class="lg:absolute right-1 -bottom-7 xl:w-[312px] lg:w-[250px] w-10/12 mx-auto" sizes="xs:231px sm:260px md:260px lg:260px xl:312px 2xl:312px" width="312" height="447" loading="lazy" format="webp" />
                          
                    </div>



                </div>
                <!-- Green Status Bar -->
                <div class="flex flex-col justify-start items-center p-3 mt-4 text-white shadow-sm md:flex-row md:gap-4"
                    style="background-color: #7BBD41">
                    <div class="px-3 py-1 mb-2 text-base font-bold text-gray-900 xl:text-22 lg:text-lg font-ww-bold md:mb-0"
                        style="background-color: #F4EB4C">
                        {{ statusLabel }}
                    </div>
                    <div class="flex gap-2 items-center text-base xl:text-22 lg:text-lg font-ww-bold">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.2603 2.83594L7.82422 8.34756L13.5406 10.8812L25.9766 5.3694L20.2603 2.83594Z"
                                fill="white" />
                            <path
                                d="M5.96838 7.52576L18.4045 2.01414L14.1506 0.12903C13.9587 0.0439525 13.751 0 13.5411 0C13.3311 0 13.1235 0.0439525 12.9315 0.12903L1.10547 5.37049L5.96838 7.52576Z"
                                fill="white" />
                            <path
                                d="M12.7875 12.193L0 6.52539V21.3207C4.20268e-05 21.6119 0.0846221 21.8969 0.243474 22.141C0.402326 22.3851 0.628619 22.5778 0.894885 22.6958L12.7874 27.9665L12.7875 12.193Z"
                                fill="white" />
                            <path
                                d="M14.293 22.3535V27.9672L15.9047 27.2528C14.8563 25.8346 14.2913 24.1171 14.293 22.3535Z"
                                fill="white" />
                            <path
                                d="M22.5672 14.0789C24.1705 14.0775 25.7392 14.5449 27.0804 15.4235V6.52539L14.293 12.193V22.3531C14.2954 20.1594 15.168 18.0563 16.7191 16.5051C18.2703 14.9539 20.3735 14.0814 22.5672 14.0789Z"
                                fill="white" />
                            <path
                                d="M22.5667 15.584C21.2278 15.584 19.9189 15.981 18.8056 16.7249C17.6923 17.4688 16.8246 18.5261 16.3122 19.7631C15.7998 21.0001 15.6657 22.3613 15.927 23.6745C16.1882 24.9877 16.8329 26.194 17.7797 27.1408C18.7265 28.0876 19.9328 28.7323 21.246 28.9935C22.5592 29.2548 23.9204 29.1207 25.1574 28.6083C26.3944 28.0959 27.4517 27.2282 28.1956 26.1149C28.9395 25.0016 29.3365 23.6927 29.3365 22.3538C29.3365 20.5583 28.6233 18.8364 27.3537 17.5668C26.0841 16.2972 24.3622 15.584 22.5667 15.584ZM26.1073 21.3812L22.3463 25.1422C22.2765 25.212 22.1936 25.2675 22.1023 25.3053C22.0111 25.3431 21.9133 25.3625 21.8145 25.3625C21.7157 25.3625 21.6179 25.3431 21.5267 25.3053C21.4354 25.2675 21.3525 25.212 21.2827 25.1422L19.4022 23.2617C19.2638 23.1201 19.1868 22.9296 19.188 22.7316C19.1891 22.5337 19.2683 22.3441 19.4083 22.2041C19.5482 22.0641 19.7378 21.985 19.9358 21.9838C20.1338 21.9827 20.3242 22.0597 20.4658 22.198L21.8145 23.5465L25.0437 20.3175C25.1132 20.2463 25.1962 20.1897 25.2878 20.1508C25.3794 20.1119 25.4778 20.0916 25.5773 20.091C25.6768 20.0905 25.7754 20.1096 25.8675 20.1475C25.9595 20.1853 26.0431 20.241 26.1135 20.3113C26.1838 20.3817 26.2395 20.4653 26.2773 20.5574C26.3152 20.6494 26.3343 20.748 26.3338 20.8475C26.3332 20.947 26.3129 21.0454 26.274 21.137C26.2351 21.2286 26.1785 21.3116 26.1073 21.3811V21.3812Z"
                                fill="white" />
                        </svg>

                        {{ statusText }}
                    </div>
                </div>
            </div>

            <!-- Bottom Text -->
            <div class="text-base xl:text-xl md:text-lg font-ww-regular">
                <div v-html="bottomText">
                </div>
            </div>



        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    headerTitle: {
        type: String,
        default: 'Lifeboost isn\'t coffee — it\'s peace of mind in a cup.'
    },
    headerDescription: {
        type: String,
        default: 'Every sip says: I\'m doing something good for my body, the planet, and the people who grow it.'
    },
    boxTitle: {
        type: String,
        default: 'Why We\'ll <span class="text-red-600">Never Charge You Full Price</span> for Shipping (And How Buying More Actually Saves the Planet)'
    },
    boxImageSrc: {
        type: String,
        default: '/assets/images/image-product-med-r.png'
    },
    boxImageAlt: {
        type: String,
        default: 'Lifeboost Coffee Bag'
    },
    statusLabel: {
        type: String,
        default: 'Current Status:'
    },
    statusText: {
        type: String,
        default: 'In Stock. Your Order Will Ship Today.'
    },
    bottomText: {
        type: String,
        default: 'Our pricing philosophy is simple: Buy more, save more, help the planet. We believe in bulk discounting because it benefits everyone—you get better prices, we pass on our shipping and volume savings, and together we reduce our carbon footprint. A single bag costs us over $13 just to ship, but when you buy in bulk, we save tremendously on packaging, cardboard, and fuel—and we pass every penny of those savings directly to you.'
    }
})

defineBuilderComponent({
    friendlyName: 'BannerInfoWithImage',
    inputs: [
        {
            name: 'headerTitle',
            type: 'richText',
            friendlyName: 'Header Title',
            defaultValue: 'Lifeboost isn\'t coffee — it\'s peace of mind in a cup.'
        },
        {
            name: 'headerDescription',
            type: 'richText',
            friendlyName: 'Header Description',
            defaultValue: 'Every sip says: I\'m doing something good for my body, the planet, and the people who grow it.'
        },
        {
            name: 'boxTitle',
            type: 'richText',
            friendlyName: 'Box Title',
            defaultValue: 'Why We\'ll <span class="text-red-600">Never Charge You Full Price</span> for Shipping (And How Buying More Actually Saves the Planet)'
        },
        {
            name: 'boxImageSrc',
            type: 'file',
            friendlyName: 'Box Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/image-product-med-r.png'
        },
        {
            name: 'boxImageAlt',
            type: 'text',
            friendlyName: 'Box Image Alt',
            defaultValue: 'Lifeboost Coffee Bag'
        },
        {
            name: 'statusLabel',
            type: 'text',
            friendlyName: 'Status Label',
            defaultValue: 'Current Status:'
        },
        {
            name: 'statusText',
            type: 'text',
            friendlyName: 'Status Text',
            defaultValue: 'In Stock. Your Order Will Ship Today.'
        },
        {
            name: 'bottomText',
            type: 'richText',
            friendlyName: 'Bottom Text',
            defaultValue: 'Our pricing philosophy is simple: Buy more, save more, help the planet. We believe in bulk discounting because it benefits everyone—you get better prices, we pass on our shipping and volume savings, and together we reduce our carbon footprint. A single bag costs us over $13 just to ship, but when you buy in bulk, we save tremendously on packaging, cardboard, and fuel—and we pass every penny of those savings directly to you.'
        }
    ]
})
</script>

<style scoped></style>